import { awardCategories2021, winners2021 } from './data';
import { Footer2021, Header2021, use2021Page } from './shared';

const Winners2021 = () => {
  const { lang } = use2021Page('Smart Living Partnership Awards 2021 - Winners');
  return (
    <>
      <Header2021 lang={lang} currentPath="winners" />
      <main>
        <div className="background-container" style={{ backgroundImage: 'url(/2021/images/awards.png)', marginTop: '8.1%', marginLeft: '-3px' }}>
          <img src="/2021/images/awards.png" style={{ visibility: 'hidden' }} alt="" />
        </div>
        <div className="winner-main-container background-container" style={{ backgroundImage: 'url(/2021/images/awards2.png)' }}>
          <img src="/2021/images/awards2.png" style={{ visibility: 'hidden' }} alt="" />
          <div className="background-info">
            <h1><b>{lang === 'zh' ? '得獎名單' : 'Winners'}</b></h1>
            <div className="awards-category-container">
              {awardCategories2021.map((cat) => (
                <div key={cat.key}>
                  <div className="awards-bar">
                    <div className="icon"><div style={{ width: 70, height: 70, marginTop: '5%', marginLeft: '40%' }}><img src={`/2021/images/${cat.key}.png`} alt="" /></div></div>
                    <div className="title"><span>{lang === 'zh' ? cat.zh : cat.en}</span></div>
                    <div className="arrow"><div className="triangle-left"></div></div>
                  </div>
                  <div style={{ paddingTop: '1%', paddingBottom: '1%', boxShadow: '0 2px 8px #b2abb1', lineHeight: '1.5rem' }}>
                    {(winners2021[cat.key]?.[lang] || []).map((w) => (
                      <div style={{ display: 'flex' }} key={`${cat.key}-${w.id}`}>
                        <div style={{ fontWeight: 'bold', paddingLeft: '2%', width: '50%' }}>{w.award_name}</div>
                        <div style={{ width: '50%' }}>{w.awardee}</div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </main>
      <Footer2021 lang={lang} />
    </>
  );
};

export default Winners2021;
